var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.42851 8.23482C5.72686 8.23482 4.33459 6.84255 4.33459 5.14089C4.33459 3.43923 5.72686 2.04697 7.42851 2.04697C9.13017 2.04697 10.5224 3.43923 10.5224 5.14089C10.5224 6.84255 9.13017 8.23482 7.42851 8.23482ZM7.42851 3.59393C6.57768 3.59393 5.88155 4.29006 5.88155 5.14089C5.88155 5.99172 6.57768 6.68785 7.42851 6.68785C8.27934 6.68785 8.97547 5.99172 8.97547 5.14089C8.97547 4.29006 8.27934 3.59393 7.42851 3.59393Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.42859 10.5553C3.17445 10.5553 0.699307 6.06906 0.544611 5.91437C0.389915 5.68232 0.389915 5.37293 0.544611 5.14089C0.621959 4.98619 3.17445 0.5 7.42859 0.5C11.6827 0.5 14.1579 4.98619 14.3126 5.14089C14.4673 5.37293 14.4673 5.68232 14.3126 5.91437C14.1579 6.06906 11.6827 10.5553 7.42859 10.5553ZM2.16892 5.52763C2.78771 6.53315 4.72141 9.00829 7.42859 9.00829C10.1358 9.00829 12.0695 6.53315 12.6883 5.52763C12.0695 4.5221 10.1358 2.04696 7.42859 2.04696C4.72141 2.04696 2.78771 4.5221 2.16892 5.52763Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIcon);
export default __webpack_public_path__ + "static/media/view_icon.39439c3bcb03a8e222051234c7148a1d.svg";
export { ForwardRef as ReactComponent };